import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { Activity, ChevronDown } from "lucide-react";

const RANGES = [["Today", 1], ["7 days", 7], ["30 days", 30]];

export default function UsageSummary() {
  const [open, setOpen] = useState(false);
  const [days, setDays] = useState(7);
  const [d, setD] = useState(null);

  const load = useCallback((n) => {
    api.get("/prospects/usage/summary", { params: { days: n } }).then((r) => setD(r.data)).catch(() => {});
  }, []);
  useEffect(() => { if (open) load(days); }, [open, days, load]);

  const Stat = ({ label, value, testid }) => (
    <div data-testid={testid}>
      <div className="text-[10px] uppercase tracking-wider text-muted-foreground">{label}</div>
      <div className="font-mono-nums font-semibold">{value}</div>
    </div>
  );

  return (
    <Collapsible open={open} onOpenChange={setOpen}>
      <div className="bg-card border border-border rounded-md px-4 py-3" data-testid="usage-summary">
        <CollapsibleTrigger asChild>
          <button className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.15em] text-muted-foreground w-full" data-testid="usage-toggle">
            <Activity className="w-4 h-4 text-accent" />Data Usage & Cache Report
            <ChevronDown className={`w-3.5 h-3.5 ml-auto transition-transform ${open ? "rotate-180" : ""}`} />
          </button>
        </CollapsibleTrigger>
        <CollapsibleContent>
          <div className="flex gap-1.5 mt-3 mb-3">
            {RANGES.map(([label, n]) => (
              <Button key={n} size="sm" variant={days === n ? "default" : "outline"} onClick={() => setDays(n)} data-testid={`usage-range-${n}`}>{label}</Button>
            ))}
          </div>
          {d && (
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 text-sm">
              <Stat label="Total Lookups" value={d.total_lookups} testid="usage-total" />
              <Stat label="Cache Hits" value={d.cache_hits} testid="usage-cache-hits" />
              <Stat label="External API Calls" value={d.external_api_calls} testid="usage-api-calls" />
              <Stat label="Cache-Hit %" value={`${d.cache_hit_pct}%`} testid="usage-hit-pct" />
              <Stat label="ATTOM Calls" value={d.attom_calls} testid="usage-attom" />
              <Stat label="Street View Calls" value={d.streetview_calls} testid="usage-streetview" />
              <Stat label="Street View Cached" value={d.streetview_cached} testid="usage-sv-cached" />
              <Stat label="Local DB Lookups" value={d.local_lookups} testid="usage-local" />
            </div>
          )}
          <p className="text-[10px] text-muted-foreground mt-2">Diagnostic report only — no keys or credentials are shown.</p>
        </CollapsibleContent>
      </div>
    </Collapsible>
  );
}
